module.exports = __webpack_public_path__ + "img/MC_Mobile.511b3fc3.png";